<script setup lang="ts">
    import { downloadShippingPackage } from '@/shared/helpers/api';
    import { http } from '@/shared/httpWrapper';
    import { useShippingStore } from '@/stores/shippingStore';
    import saveAs from 'file-saver';

    const store = useShippingStore();

    async function onDownload(): Promise<void> {
        if (!store.selectedPackage)
            return;

        const response = await downloadShippingPackage(http, store.selectedPackage.packageId);
        if (response.data) {
            const filename = (store.selectedPackage.name?.trim() || store.selectedPackage.packageId) + '.zip';
            const blob = new Blob([response.data], { type: response.headers['Content-Type']?.toString() });
            saveAs(blob, filename);
        }
    }
</script>

<template>
    <template v-if="store.isDownloadAvailable">
        <div
            class="block">
            <div class="shipping-section-header block">
                Download
            </div>
            <div class="is-size-5">
                The package has been created and is ready to be transported to another Common Library environment.
                Download the package zip file to your local disk.
                Then navigate to the target Common Library environment,
                open the Shipping user interface, upload the package there, and follow the instructions.
            </div>
        </div>
        <div
            class="is-flex is-justify-content-center pt-5 pb-5">
            <b-button
                type="is-primary"
                size="is-large"
                outlined
                @click="onDownload">
                Download package
            </b-button>
        </div>
    </template>
</template>
